// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"a8a00c6c","921":"e26e0b67"}[chunkId] + ".chunk.js";
};